import React from "react";
import { useTranslation } from "react-i18next";

import { ProfileNavigation } from "@common/profileNavigation";
import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { Preferences } from "../../scenes/preferences";
import { Props } from "./types";
import styles from "./styles.scss";

function AccountPage(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.account}>
      <div className={styles.header}>
        <h1 className={styles.title}>{t("accountPage.title")}</h1>
        <div className={styles.profileNavigation}>
          <AssistantShortcut />
          <Notifications />
          <ProfileNavigation />
        </div>
      </div>
      <div className={styles.main}>
        <div className={styles.content}>
          <Preferences />
        </div>
      </div>
    </div>
  );
}

export { AccountPage };
